import { render, staticRenderFns } from "./TerminosView.vue?vue&type=template&id=70bddcac&scoped=true&"
import script from "./TerminosView.vue?vue&type=script&lang=ts&"
export * from "./TerminosView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bddcac",
  null
  
)

export default component.exports